//TODO: https://localforage.github.io/localForage/
//TODO: VUE localstorage extended - https://github.com/ricardogobbosouza/v-localforage
import { defineModule } from "direct-vuex"
import { moduleActionContext, moduleGetterContext } from "."
import ApiServices from "Api/ApiFactory"
import { IDWUserViewModel, DWUserViewModel } from "Api/DynamicwebApi";
import jwt_decode  from "jwt-decode";
import ApiFactory from "Api/ApiFactory";

let promise: Promise<any>;

const expirationTime = 1000 * 60*60;

//const dynamicWebApiClient = ;

export interface IUserState {
    status: string;
    user: IDWUserViewModel;
    userExpires: number;
}
const parseUserFromLocalStorage = () =>{
    var localStorageObj = localStorage.getItem('current-user');
    if(localStorageObj)
    {
        var test = DWUserViewModel.fromJS(JSON.parse(localStorageObj));
        return test;
    }
    return null;
}

const initial: IUserState = {
    status: '',
    user: parseUserFromLocalStorage(),
    userExpires: parseInt(localStorage.getItem('user-expires'))
}




const auth = defineModule({
    namespaced: true,
    state: (): IUserState =>{
        return initial
    },
    getters: {
        getToken(...args): string {
            const { state, getters, rootState, rootGetters } = mod1GetterContext((args) as any);
            if (state.user) return state.user.token;
            return null;
        },
        hasRole(...args): boolean {
            const { state, getters, rootState, rootGetters } = mod1GetterContext((args) as any);
            return false; //TODO:
        },
        authStatus(...args): string {
            const { state, getters, rootState, rootGetters } = mod1GetterContext((args) as any);
            return state.status;
        }
    },
    mutations: {
        AUTH_REQUEST(state) {
            state.status = 'loading';
        },
        AUTH_SUCCESS(state, payload: { user: IDWUserViewModel, userExpires: number }) {
            localStorage.setItem('current-user', JSON.stringify(payload.user));  
            state.user = payload.user;
            state.userExpires = payload.userExpires;
            state.status = '';
        },
        AUTH_ERROR(state, error) {
            localStorage.removeItem('current-user'); 
            state.status = 'error';
        },
        AUTH_LOGOUT(state) {
            localStorage.removeItem('current-user'); 
            state.user = null;
            state.status = '';
        },
        AUTH_REFRESH(state) {
            state.user = null;
        }
    },
    actions: {
        //TODO: 
        //preconditions - DW LOGGED IN USER
        //IF USER IS NOT LOGGED IN - REMOVE TOKEN FORM LOCALSTORAGE TO PREVENT CORRUPTED TOKENS
        async loadUser(context) : Promise<any> {
            const { dispatch, commit, getters, state } = authActionContext(context);
            // console.log('before promise');
            return promise || (promise = new Promise(async (resolve, reject) => {
                try {
                    const result = await ApiFactory.getDynamicwebClient().getCurrentUser(localStorage.getItem('extendKey') ?? '');
                    if (result) {
                        commit.AUTH_SUCCESS({
                            user: result,
                            userExpires: 0
                        });
                        resolve();
                    }
                } catch (err) {
                    commit.AUTH_ERROR(err);
                    reject();
                }
            }));
        },
        async refreshUser(context){
            const { dispatch, commit, getters, state } = authActionContext(context);
            const currentTime = new Date().getTime();
            //if(state.user == null || state.userExpires >  ) 
        },
             //TODO: make async - dispatch from logout
        async clearUser(context) {
            const { dispatch, commit, getters, state } = authActionContext(context); 
            commit.AUTH_LOGOUT();
        },
    }
});

export default auth
const mod1GetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, auth);
const authActionContext = (context: any) => moduleActionContext(context, auth);